import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { AlertTriangle } from 'lucide-react';
import { cn } from '../../lib/utils';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';

const MainLayout = ({ title = 'Dashboard' }) => {
  const { theme } = useAuth();
  const { darkMode } = useTheme();

  return (
    <div className={cn(
      "min-h-screen transition-colors duration-300",
      darkMode ? "bg-gradient-to-br from-[#1f1a1a] via-[#1a1717] to-[#1f1a1a]" : "bg-stone-50"
    )}>
      {/* Sidebar */}
      <Sidebar />

      {/* Main content - ajustado para sidebar de 56 no desktop */}
      <div className="lg:ml-56 min-h-screen flex flex-col">
        {/* Mobile top padding para o header fixo */}
        <div className="h-14 lg:hidden" />
        
        <Header title={title} />
        
        {/* Aviso de descontinuação */}
        <div data-testid="aviso-descontinuacao" className="mx-4 sm:mx-6 mt-3 flex items-start gap-3 rounded-lg border border-red-500/40 bg-red-600/15 px-4 py-2.5">
          <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
          <p className="text-xs sm:text-sm leading-snug text-red-600 dark:text-red-400">
            <span className="font-bold uppercase">Aviso — sistema em descontinuação:</span>{' '}
            utilize o <span className="font-semibold">ponto da Flash</span> e as <span className="font-semibold">soluções integradas de RH da Flash</span>, para não ficar com dados soltos sem sincronia.
            A gestão operacional e demais rotinas passam a ser feitas no <span className="font-semibold">SlapFestas</span>, sistema escolhido pelo Tomaselli — motivo pelo qual este sistema será descontinuado.
          </p>
        </div>
        
        <main className="flex-1 p-4 sm:p-6 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
